import { render, staticRenderFns } from "./CDropdown.vue?vue&type=template&id=059b5742"
import script from "./CDropdown.vue?vue&type=script&lang=ts"
export * from "./CDropdown.vue?vue&type=script&lang=ts"
import style0 from "./CDropdown.vue?vue&type=style&index=0&id=059b5742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
